export const WA_MAIN = "5592984665854";
export const WA_ALT = "5592985665131";
export const WA_MAIN_LABEL = "(92) 98466-5854";
export const WA_ALT_LABEL = "(92) 98566-5131";
export const ADDRESS = "Av. Brigadeiro Hilário Gurjão, Nº 1830 — Jorge Teixeira, Manaus – AM";
export const ADDRESS_REF = "Em frente à Clínica da Família Fábio Couto Vale";
export const INSTAGRAM = "https://www.instagram.com/destak.am";
export const EMAIL_PLACEHOLDER = "[e-mail a definir]";

export const waLink = (text = "Olá, Destak! Gostaria de fazer um orçamento.", num = WA_MAIN) =>
  `https://wa.me/${num}?text=${encodeURIComponent(text)}`;

export const NAV = [
  { id: "inicio", label: "Início" },
  { id: "produtos", label: "Produtos" },
  { id: "sobre", label: "Sobre Nós" },
  { id: "diferenciais", label: "Diferenciais" },
  { id: "contato", label: "Contato" },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: id === "inicio" ? 0 : -70, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const PRODUCTS = [
  {
    slug: "comum",
    name: "Compensado Comum",
    tag: "Versátil",
    img: "/img/comum.jpg",
    text: "Uma opção versátil e econômica para diferentes aplicações na construção, marcenaria e projetos em geral.",
  },
  {
    slug: "resinado",
    name: "Compensado Resinado",
    tag: "Resistente à umidade",
    img: "/img/resinado-rosa.jpg",
    text: "Resistência e qualidade para aplicações que exigem maior durabilidade e proteção contra umidade.",
  },
  {
    slug: "naval",
    name: "Compensado Naval Plastificado",
    tag: "Alto desempenho",
    img: "/img/naval-azul.jpg",
    text: "Alta resistência e excelente durabilidade para aplicações que exigem maior desempenho do material.",
  },
];

export const ease = [0.16, 1, 0.3, 1];

export const SHEET_W = 1.22;
export const SHEET_H = 2.44;
